import React, { Component } from 'react'
// import { PropTypes } from 'prop-types'
// import { get } from 'lodash'
import { Input } from 'components/fields'
import { Button } from 'components/misc'
import { FieldArray } from 'redux-form'

export default class Question extends Component {
  static propTypes = {}

  renderOptions = ({ fields }) => {
    return (
      <div>
        {fields.map((option, index) => (
          <div key={index} className="row">
            <div className="col-xs-9">
              <Input
                label="Option"
                intlKey="label.option"
                name={`${option}.value`}
              />
              <Input
                label="Option"
                type="hidden"
                labelless
                intlKey="label.option"
                name={`${option}.id`}
              />
            </div>
            <div className="col-xs-3">
              <Button
                negative
                justify
                type="button"
                onClick={() => fields.remove(index)}
                intlKey="button.remove"
              >
                Remove
              </Button>
            </div>
          </div>
        ))}
        <div>
          <Button
            secondary
            intlKey="button.add_option"
            type="button"
            onClick={() => fields.push({})}
          >
            Add option
          </Button>
        </div>
      </div>
    )
  }

  render() {
    return (
      <div>
        <FieldArray name="questionOptions" component={this.renderOptions} />
      </div>
    )
  }
}
